import { render } from "./FileManager.vue?vue&type=template&id=3e4b3c65&scoped=true"
import script from "./FileManager.vue?vue&type=script&lang=ts"
export * from "./FileManager.vue?vue&type=script&lang=ts"

import "./FileManager.vue?vue&type=style&index=0&id=3e4b3c65&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3e4b3c65"

export default script